import { Login } from '@mui/icons-material'
import { Box } from '@mui/material'
import { Control, FieldErrors } from 'react-hook-form'
import CustomTextField from 'src/components/mui/CustomInput'
import { EmailVerificationDialogValues } from './EmailVerificationDialog'

interface EmailVerificationFormProps {
  control: Control<EmailVerificationDialogValues, any>
  errors: FieldErrors<EmailVerificationDialogValues>
  handleSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>
  disabled: boolean
}

const EmailVerificationForm = ({
  control,
  errors,
  handleSubmit,
  disabled
}: EmailVerificationFormProps) => {
  return (
    <Box pt={'30px'}>
      <Box display="flex" flexDirection="column" gap={2}>
        <CustomTextField
          fullWidth
          name="email"
          type="email"
          control={control}
          label="Email*"
          placeholder="Enter your email"
          errors={errors}
        />
        <CustomTextField
          fullWidth
          name="name"
          control={control}
          label="Full Name*"
          placeholder="Enter your name"
          errors={errors}
        />

        <CustomTextField
          fullWidth
          name="designation"
          control={control}
          label="Title*"
          placeholder="Enter your designation title"
          errors={errors}
        />

        <CustomTextField
          fullWidth
          name="organization"
          control={control}
          label="Company name*"
          placeholder="Enter your company name"
          errors={errors}
        />

        <button
          onClick={handleSubmit}
          disabled={disabled}
          className={`w-full py-4 rounded-[4px] mt-[16px] text-[14px] bg-[#186174] text-white text-center disabled:opacity-50 disabled:cursor-not-allowed mb-2`}>
          <Login />
          <span className="text-white ml-2">Submit</span>
        </button>
      </Box>
    </Box>
  )
}

export default EmailVerificationForm
